/**
 * IDENTIFIKATORNING QISQARTIRILGAN SHAKLI — YAGONA nusxa.
 *
 * =====================================================================
 * ⚠️ NEGA BU FAYL PAYDO BO'LDI (B4 + B5, tashqi tester 2026-08-14)
 * =====================================================================
 * Ikkala nuqson ham bitta sinfda: ekranda NOM emas, IDENTIFIKATOR
 * ko'rinardi. Ularni tuzatishda «zaxira shakl» kerak bo'ldi — nom
 * topilmaganda nima chizish. Va o'shanda ma'lum bo'ldiki, bu zaxira
 * shakl repoda ALLAQACHON to'qqiz joyda, UCH XIL ko'rinishda yozilgan:
 *
 *   `id.length > 8 ? id.slice(0, 8) + '…' : id`   AuditPage, LedgerPage
 *   `id.slice(0, 8)`            (uchsiz)          AttendanceEventsPage,
 *                                                 EmployeeSyncTags,
 *                                                 WarehouseRef, SiteRef,
 *                                                 AgentRef
 *   `id.slice(0, 8) + '…'`      (shartsiz)        RecentAuditPanel
 *
 * Oqibati ko'rinib turibdi: BIR aktyor ikki ekranda ikki xil
 * ko'rinadi — birida `3ae69369`, ikkinchisida `3ae69369…`. Operator
 * ularni bir narsa deb tanimasligi mumkin, ya'ni nusxa nafaqat
 * ortiqcha kod, balki NUQSON manbai.
 *
 * ⚠️ Shuning uchun B4 va B5 ga ALOHIDA yamoq qo'yilmadi: ikkalasi ham
 * shu bitta funksiyani chaqiradi. Qolgan yetti joy bu topshiriq
 * doirasidan tashqarida (boshqa agentlar tegayotgan fayllar) —
 * ular reyestrga yozildi, jimgina qoldirilmadi.
 *
 * =====================================================================
 * ⚠️ NEGA AYNAN 8 BELGI VA UCHTA NUQTA
 * =====================================================================
 * 8 — mavjud ekranlarning ko'pchiligidagi qiymat, ya'ni o'zgarish eng
 * kam ekranga tegadi. Uchta nuqta MAJBURIY: usiz `3ae69369`
 * to'liq identifikatordek ko'rinadi va uni nusxa olib qidirgan odam
 * hech narsa topmaydi. Nuqta esa «bu bo'lak» deb ochiq aytadi.
 *
 * ⚠️ Qiymat 8 belgidan qisqa bo'lsa u QIRQILMAYDI va nuqta ham
 * qo'shilmaydi — aks holda to'liq ko'rsatilgan qisqa qiymat
 * («SYSTEM») kesilgandek ko'rinardi.
 */
export const SHORT_ID_LENGTH = 8

export function shortId(raw: string): string {
  const value = raw.trim()
  return value.length <= SHORT_ID_LENGTH ? value : `${value.slice(0, SHORT_ID_LENGTH)}…`
}
